import { useMemo } from "react";

export interface IRoutePaths {
    visitatieRapporten: string,
    visitatieRapportenEdit: string,
    goedePraktijken: string,
    goedePraktijkenEdit: string,
    shms: string,
    gemeenten: string,
    themas: string,
    operationeleDoelstellingen: string,
    gebruikers: string,
    documenten: string,
    zoekRapporten: string,
    zoekGoedePraktijken: string,
    zoekShmPrestaties: string,
}

const useAppRoutes = () => {

    const routePaths = useMemo((): IRoutePaths => ({
        visitatieRapporten: "/visitatierapporten",
        visitatieRapportenEdit: "/visitatierapporten/:id",
        goedePraktijken: "/goedepraktijken",
        goedePraktijkenEdit: "/goedepraktijken/:id",
        shms: "/shms",
        gemeenten: "/gemeenten",
        themas: "/themas",
        operationeleDoelstellingen: "/operationeledoelstellingen",
        gebruikers: "/gebruikers",
        documenten: "/documenten",
        zoekRapporten: "/zoek/rapporten",
        zoekGoedePraktijken: "/zoek/goede-praktijken",
        zoekShmPrestaties: "/zoek/shm-prestaties",
    }), [])

    return routePaths;
}
export default useAppRoutes;